var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("Warehouse.Statistics"),
            width: "320px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "form-row",
                  staticStyle: { display: "flex", "flex-direction": "row" }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Warehouse.Number"),
                                    prop: "warehouseNo"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "number", disabled: true },
                                    model: {
                                      value: _vm.page.number,
                                      callback: function($$v) {
                                        _vm.$set(_vm.page, "number", $$v)
                                      },
                                      expression: "page.number"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: {
                                    label: _vm.$t("Warehouse.QuantityActual"),
                                    prop: "receiptNo"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "quantity", disabled: true },
                                    model: {
                                      value: _vm.page.quantity,
                                      callback: function($$v) {
                                        _vm.$set(_vm.page, "quantity", $$v)
                                      },
                                      expression: "page.quantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: {
                                    label: _vm.$t("Warehouse.WeightActual"),
                                    prop: "receiptNo"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "weight", disabled: true },
                                    model: {
                                      value: _vm.page.weight,
                                      callback: function($$v) {
                                        _vm.$set(_vm.page, "weight", $$v)
                                      },
                                      expression: "page.weight"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "auto-width",
                                  attrs: {
                                    label: _vm.$t("Warehouse.CubageActual"),
                                    prop: "receiptNo"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "cubage", disabled: true },
                                    model: {
                                      value: _vm.page.cubage,
                                      callback: function($$v) {
                                        _vm.$set(_vm.page, "cubage", $$v)
                                      },
                                      expression: "page.cubage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "spacing" }),
            _c(
              "div",
              { staticClass: "triggers", attrs: { align: "right" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel", type: "primary" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.close")) + " ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }